// src/components/InputRow.js
import React from 'react';

const InputRow = ({ typedWord, expectedLength, isShaking }) => {
    const getFontSizeClass = (length) => {
        if (length > 9) return 'text-2xl sm:text-3xl';
        return 'text-3xl sm:text-4xl'; // Only one size change for very long words
    };

    const getTileSizeClass = (length) => {
        if (length > 12) return 'w-8 h-8 sm:w-10 sm:h-10';
        if (length > 10) return 'w-9 h-9 sm:w-12 sm:h-12';
        return 'w-10 h-10 sm:w-14 sm:h-14';
    };

    const getSpacingClass = (length) => {
        if (length > 10) return 'space-x-0.5 sm:space-x-1';
        return 'space-x-1 sm:space-x-2';
    };

    return (
        <div className={`flex justify-center items-center my-4 ${getSpacingClass(expectedLength)} ${isShaking ? 'animate-shake' : ''} ${getFontSizeClass(expectedLength)}`}>
            {Array.from({ length: expectedLength }).map((_, index) => (
                <div
                    key={index}
                    className={`font-bold uppercase flex items-center justify-center rounded-md ${getTileSizeClass(expectedLength)} ${typedWord[index] ? 'bg-white dark:bg-dark-key-bg shadow-md' : 'border-2 border-dashed border-gray-300 dark:border-gray-600'}`}
                >
                    {typedWord[index] || ''}
                </div>
            ))}
        </div>
    );
};

export default InputRow;
